__turbopack_context__.v({
  "arrow": "contact-link-module__wHQCKG__arrow",
  "button": "contact-link-module__wHQCKG__button",
  "card": "contact-link-module__wHQCKG__card",
  "description": "contact-link-module__wHQCKG__description",
  "emailIcon": "contact-link-module__wHQCKG__emailIcon",
  "emailLink": "contact-link-module__wHQCKG__emailLink",
  "emailRow": "contact-link-module__wHQCKG__emailRow",
  "icon": "contact-link-module__wHQCKG__icon",
  "iconWrapper": "contact-link-module__wHQCKG__iconWrapper",
  "title": "contact-link-module__wHQCKG__title",
});
